import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import { MdEmail, MdLocalPhone, MdLocationOn } from 'react-icons/md';
import { FaLinkedinIn } from 'react-icons/fa';
import './contactStyle.css';
import CircleVector from '../../../../../assets/icons/circle_vector.svg';
import userService from '../../../../../services/user.service';
import { Link } from 'react-router-dom';
import { IoLogoFacebook } from 'react-icons/io';

const { TextArea } = Input;

const ContactUs = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const handleSubmit = (values) => {
    setLoading(true);
    userService
      .sendVisitorsMessage({
        name: values.name,
        email: values.email,
        subject: values.subject,
        message: values.message,
      })
      .then((res) => {
        message.success(res?.message, [10]);
        console.log(res);
        form.resetFields();
        form.setFieldsValue({});
      })
      .catch((error) => {
        message.error(error?.errors || error?.message, [10]);
        console.log(error);
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className="contact_us_container  py-20 sm:py-10  px-4 sm:px-0">
      <div className="contact_left_box sm:h-[470px]  p-10 sm:p-6">
        <div className="">
          <div>
            <h3 className="contact_us_head sm:text-3xl">Contact us</h3>
            <p className="contact_us_head_sub sm:text-sm">
              Fill up the form and our friendly team will get back to you within 24hrs.
            </p>
          </div>
          <div className="mt-10  sm:mt-6 space-y-5  sm:space-y-2">
            <span className="contact_item  sm:gap-3 sm:text-sm">
              <MdLocalPhone className="text-2xl sm:text-lg" />
              <p> +234 904 000 4400</p>
            </span>
            <span className="contact_item sm:gap-3  sm:text-sm">
              <MdEmail className="text-2xl sm:text-lg" />
              <p>hello@xolanihealth.com</p>
            </span>
            <span className="contact_item  sm:gap-3 sm:text-sm">
              <MdLocationOn className="text-2xl sm:text-lg" />
              <p className="z-10"> No. 5, Kwaji Close, Maitama - Abuja, Nigeria.</p>
            </span>
          </div>
        </div>
        <div className="contact_social">
          <Link to="mailto:xolanihealth@gmail.com?subject=Hello" title="Send an Email">
            <MdEmail size={20} />
          </Link>
          <Link to="https://web.facebook.com/xolanihealth" target="_blank" title="Follow us on Facebook">
            <IoLogoFacebook size={20} />
          </Link>
          <Link
            to="https://www.linkedin.com/company/xolanihealth/posts/?feedView=all"
            target="_blank"
            title="Follow us on LinkedIn"
          >
            <FaLinkedinIn size={20} />
          </Link>
        </div>
        <img src={CircleVector} alt="vector" className="img_vector z-0 sm:h-[200px]" loading="lazy" />
      </div>
      <Form form={form} onFinish={handleSubmit} layout="vertical" className="flex-1 mt-4 py-6">
        <Form.Item
          label="Name"
          name="name"
          className="mb-[16px] [&>div>div]:pb-[4px] [&>div>div>label]:text-sm [&>div>div>label]:text-dark dark:[&>div>div>label]:text-white60 [&>div>div>label]:font-medium w-full"
          rules={[{ required: true, message: 'Please input your name!' }]}
        >
          <Input placeholder="Enter your name" />
        </Form.Item>
        <Form.Item
          label="Email Address"
          name="email"
          className="mb-[16px] [&>div>div]:pb-[4px] [&>div>div>label]:text-sm [&>div>div>label]:text-dark dark:[&>div>div>label]:text-white60 [&>div>div>label]:font-medium w-full"
          rules={[{ required: true, message: 'Please input your email!', type: 'email' }]}
        >
          <Input placeholder="Enter your email address" />
        </Form.Item>

        <Form.Item
          label="Subject"
          name="subject"
          className="mb-[16px] [&>div>div]:pb-[4px] [&>div>div>label]:text-sm [&>div>div>label]:text-dark dark:[&>div>div>label]:text-white60 [&>div>div>label]:font-medium w-full"
          rules={[{ required: true, message: 'Please input your subject' }]}
        >
          <Input placeholder="Enter appropriate title for your message" />
        </Form.Item>
        <Form.Item
          name="message"
          label="Message"
          className="mb-[16px] [&>div>div]:pb-[4px]"
          rules={[{ required: true, message: 'Please input your message!' }]}
        >
          <TextArea placeholder="Leave us a message" rows={6} />
        </Form.Item>
        <div className="flex justify-end">
          <Button
            className="text-sm font-medium text-white border-none h-[40px] flex items-center justify-center rounded-[10px] px-[20px]"
            style={{ backgroundColor: '#0796A7' }}
            size="large"
            htmlType="submit"
            loading={loading}
          >
            Send Your Message
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default ContactUs;
